// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminBookingCustomerResponse

export type AdminBookingCustomerApiResponse = {
	id: string;
	firstname: string;
	lastname: string;
	email: string;
	phone: string | null;
};

export type AdminBookingCustomer = {
	id: string;
	firstname: string;
	lastname: string;
	email: string;
	phone: string | null;
};

export function hydrateAdminBookingCustomer(data: AdminBookingCustomerApiResponse): AdminBookingCustomer {
	return { ...data };
}